import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { useSelector } from 'react-redux'
import * as Selectors from 'state/selectors'


import Main from './Main'
import Settings from './Settings'

const Routing = () => {
  const hasAdminPermissions = useSelector(Selectors.hasAdminPermissions)
    
  return (
    <Switch>
      {
        hasAdminPermissions && (
          <Route
            path={`${process.env.CHAT_PUBLIC_PATH}/settings`}
            component={Settings}
          />
        )
      }
      
      <Route
        path={`${process.env.CHAT_PUBLIC_PATH}/:filterType?/:filterId?/:interactionId?`}
        component={Main}
      />

      <Redirect
        to={`${process.env.CHAT_PUBLIC_PATH}/filter/assignee`}
      />
    </Switch>
  )
}

export default Routing
